import {
    CakeIcon,
    ChevronDownIcon,
    CircleCheckIcon,
    CircleDotIcon,
    CircleInfoIcon,
    DashboardIcon,
    EmailIcon,
    MedicalIcon,
    PhoneIcon,
    PinIcon,
    RoundedSquareIcon,
    RulerIcon,
    StoreCreditIcon,
} from "@xola/icons";
import { isStringEqual } from "common";
import { ElementType } from "react";
import { Field, FieldType } from "types";

export enum QuestionnaireModalType {
    EMAIL = "email_type",
    PHONE = "phone_type",
    PICKUP = "pickup_type",
    HEIGHT = "height_type",
    WEIGHT = "weight_type",
    BIRTH_DATE = "birth_date_type",
    ADDRESS = "address_type",
    MEDICAL_CONDITIONS = "medical_conditions_type",
    /* @deprecated */
    OPT_IN = "opt_in_type",
    MARKETING_CONSENT = "marketing_consent_type",
    HOW_HEAR_US = "how_hear_us_type",
    SHORT_TEXT = "short_text_type",
    LONG_TEXT = "long_text_type",
    CHECKBOX = "checkbox_type",
    DROPDOWN = "dropdown_type",
    ADDON = "merchandise_type",
}

interface QuestionInfo {
    type: QuestionnaireModalType;
    name: string;
    icon: ElementType;
    fieldType: FieldType;
}

export const PredefinedQuestions: QuestionInfo[] = [
    {
        type: QuestionnaireModalType.EMAIL,
        name: "Email",
        icon: EmailIcon,
        fieldType: FieldType.EMAIL,
    },
    {
        type: QuestionnaireModalType.PHONE,
        name: "Phone",
        icon: PhoneIcon,
        fieldType: FieldType.PHONE,
    },
    {
        type: QuestionnaireModalType.PICKUP,
        name: "Pickup Location",
        icon: StoreCreditIcon,
        fieldType: FieldType.TEXT,
    },
    {
        type: QuestionnaireModalType.HEIGHT,
        name: "Height",
        icon: RulerIcon,
        fieldType: FieldType.HEIGHT,
    },
    {
        type: QuestionnaireModalType.WEIGHT,
        name: "Weight",
        icon: DashboardIcon,
        fieldType: FieldType.WEIGHT,
    },
    {
        type: QuestionnaireModalType.BIRTH_DATE,
        name: "Date of birth",
        icon: CakeIcon,
        fieldType: FieldType.DATE_OF_BIRTH,
    },
    {
        type: QuestionnaireModalType.ADDRESS,
        name: "Address",
        icon: PinIcon,
        fieldType: FieldType.TEXTAREA,
    },
    {
        type: QuestionnaireModalType.MEDICAL_CONDITIONS,
        name: "Medical conditions",
        icon: MedicalIcon,
        fieldType: FieldType.TEXTAREA,
    },
    {
        type: QuestionnaireModalType.MARKETING_CONSENT,
        name: "Marketing Consent",
        icon: EmailIcon,
        fieldType: FieldType.MARKETING_CONSENT,
    },
    {
        type: QuestionnaireModalType.HOW_HEAR_US,
        name: "How did you hear about us?",
        icon: CircleInfoIcon,
        fieldType: FieldType.TEXT,
    },
];

export const CustomQuestions: QuestionInfo[] = [
    {
        type: QuestionnaireModalType.SHORT_TEXT,
        name: "Short Text",
        icon: RoundedSquareIcon,
        fieldType: FieldType.TEXT,
    },
    {
        type: QuestionnaireModalType.LONG_TEXT,
        name: "Long Text",
        icon: CircleDotIcon,
        fieldType: FieldType.TEXTAREA,
    },
    {
        type: QuestionnaireModalType.CHECKBOX,
        name: "Checkbox",
        icon: CircleCheckIcon,
        fieldType: FieldType.CHECKBOX,
    },
    {
        type: QuestionnaireModalType.DROPDOWN,
        name: "Dropdown",
        icon: ChevronDownIcon,
        fieldType: FieldType.SELECT,
    },
    {
        type: QuestionnaireModalType.PICKUP,
        name: "Pickup location",
        icon: ChevronDownIcon,
        fieldType: FieldType.PICKUP,
    },
];

export const getModalType = (field: Field): QuestionnaireModalType => {
    if (field.readonly && field.label) {
        switch (field.type) {
            case FieldType.DATE_OF_BIRTH:
                return QuestionnaireModalType.BIRTH_DATE;
            case FieldType.WEIGHT:
                return QuestionnaireModalType.WEIGHT;
            case FieldType.HEIGHT:
                return QuestionnaireModalType.HEIGHT;
            case FieldType.MARKETING_CONSENT:
                return QuestionnaireModalType.MARKETING_CONSENT;
            case FieldType.EMAIL:
                return QuestionnaireModalType.EMAIL;
            default: // no case
        }

        const predefinedInfo = PredefinedQuestions.find((info) => isStringEqual(info.name, field.label))?.type;
        if (predefinedInfo) {
            return predefinedInfo;
        }
    }

    if (field.type === FieldType.ADDON) {
        return QuestionnaireModalType.ADDON;
    }

    switch (field.type) {
        case FieldType.TEXT:
            return QuestionnaireModalType.SHORT_TEXT;
        case FieldType.TEXTAREA:
            return QuestionnaireModalType.LONG_TEXT;
        case FieldType.CHECKBOX:
            return QuestionnaireModalType.CHECKBOX;
        case FieldType.SELECT:
            return QuestionnaireModalType.DROPDOWN;
        case FieldType.PICKUP:
            return QuestionnaireModalType.PICKUP;
        default: // impossible
            return QuestionnaireModalType.SHORT_TEXT;
    }
};
